import { render } from "./APILogs.vue?vue&type=template&id=772dbf22"
import script from "./APILogs.vue?vue&type=script&lang=js"
export * from "./APILogs.vue?vue&type=script&lang=js"

import "./APILogs.vue?vue&type=style&index=0&id=772dbf22&lang=css"
script.render = render

export default script